module.exports = __webpack_public_path__ + "media/images/favicon-050c57457833d93d6312c0bd3b0ed5bd.ico";